import isClient from 'lib/utils/isClient';

export function isServer() {
  return !isClient();
}

export default isServer;
